module.exports = __webpack_public_path__ + "img/t1-14.7f22fe97.png";